import { ApiConnector } from '@/integrations/api.connector';

import {
  type TFaqPageTypeRequest,
  type TFaqPageTypeResponse
} from '../types/faqPageType.types';

class AdminFaqPageTypeApi extends ApiConnector {
  private baseUrl = 'admin/faq-pages-types';

  public async getAllFaqPageTypes() {
    return this.call<unknown, TFaqPageTypeResponse[]>({
      path: this.baseUrl,
      cancelable: true
    });
  }

  public async getFaqPageType(uuid: string) {
    return this.call<unknown, TFaqPageTypeResponse>({
      path: `${this.baseUrl}/${uuid}`,
      cancelable: true
    });
  }

  public async createFaqPageType(body: TFaqPageTypeRequest) {
    return this.call<TFaqPageTypeRequest, TFaqPageTypeResponse>({
      path: this.baseUrl,
      method: 'post',
      body
    });
  }

  public async updateFaqPageType(body: TFaqPageTypeRequest) {
    return this.call<TFaqPageTypeRequest, TFaqPageTypeResponse>({
      path: `${this.baseUrl}/${body.uuid}`,
      method: 'patch',
      body
    });
  }
}

export const adminFaqPageTypeApi = new AdminFaqPageTypeApi();
